import { SwitchActiveAffiliation } from '../components';

export const handleChangeAffilication = () => SwitchActiveAffiliation;
